import {
  createContext,
  useContext,
  useEffect,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react';

import { useChannel } from '../channel';

interface UI {
  open: boolean;
  left: boolean;
}

const UIContext = createContext<{
  ui: UI;
  setUI: Dispatch<SetStateAction<UI>>;
}>(undefined!);

export const useUI = () => {
  const context = useContext(UIContext);
  return context || { ui: { open: true } };
};

export const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const { channel } = useChannel();
  const [ui, setUI] = useState<UI>({ open: false, left: false });

  useEffect(() => {
    channel?.emit('onOpenChanged', ui.open);
  }, [channel, ui.open]);

  useEffect(() => {
    channel?.emit('onLeftChanged', ui.left);
  }, [channel, ui.left]);

  return (
    <UIContext.Provider value={{ ui, setUI }}>{children}</UIContext.Provider>
  );
};
